import React from 'react';
import { BaseCorpName } from 'src/components/enterprise/features/Corporate/components/Form/common/BaseCorpName/BaseCorpName';

export interface ChildCorpNameFieldControlProps {
  name: string;
  id: string;
}

export function ChildCorpNameFieldControl({
  name,
  id,
}: ChildCorpNameFieldControlProps): JSX.Element {
  return <BaseCorpName name={name} id={id} label="Child Firm Name *" />;
}
